import type { CoreModuleOptions, CoreSiteOptions } from '../types'
import type { Merge } from 'type-fest'
import type * as Theme from '#theme'
import type { PickPaths, PublicCoreOptionPath } from '../../options/publicOptions'
import { useRuntimeConfig } from '#imports'

export const useCoreConfig = () => {
    const config = useRuntimeConfig()

    return config.public.core as unknown as
        PickPaths<Merge<CoreModuleOptions, {
            site: CoreSiteOptions
            theme: Theme.Configuration
        }>, PublicCoreOptionPath>
}
